import React from "react";
import { cn } from "../../lib/cn";

export function Title({ children, level = 3, className }) {
  const Tag = level === 1 ? "h1" : level === 2 ? "h2" : "h3";
  return (
    <Tag
      className={cn(
        "font-bold text-slate-900 tracking-tight",
        level === 1 && "text-3xl",
        level === 2 && "text-2xl",
        level >= 3 && "text-xl",
        className
      )}
    >
      {children}
    </Tag>
  );
}

export function Text({ children, type, strong, className }) {
  return (
    <span
      className={cn(
        "text-slate-700",
        strong && "font-semibold text-slate-900",
        type === "danger" && "text-red-600",
        type === "secondary" && "text-slate-500",
        className
      )}
    >
      {children}
    </span>
  );
}

export const Typography = { Title, Text };
Typography.Title = Title;
Typography.Text = Text;
